<template>
  <div id="faqSection" :class="['faq']">
    <div class="content">
      <p :class="{ 'font-weight-bold': lang === 'ru' }" v-text="translations[lang].title" class="title" />

      <div class="faq__wrapper">
        <div v-for="(item, key) in translations[lang].items" :key="key" class="faq__item">
          <div :class="{ '--active': item.active }" class="faq__head" @click="item.active = !item.active">
            <span class="faq__cross"><img src="@/assets/img/plus-no-rounded-icon.svg" alt="plus-icon" /></span>

            <p v-html="item.title" :class="{ 'font-weight-medium': lang === 'ru' }" class="faq__title" />
          </div>

          <slide-up-down :active="item.active" :duration="500" :key="key" class="faq__slide">
            <div>
              <div class="faq__description" v-html="item.description" />
            </div>
          </slide-up-down>
        </div>
      </div>

      <div class="faq__button">
        <button :class="{ 'btn-ask-question': lang === 'en' }" v-text="translations[lang].button" class="custom-button" @click="openQuestionForm('question')" />
      </div>
    </div>
  </div>
</template>

<script>
import SlideUpDown from 'vue-slide-up-down';

export default {
  name: 'FAQ',
  components: {
    SlideUpDown,
  },
  props: {
    lang: {
      type: String,
      default: 'en',
    },
    openQuestionForm: {
      default: () => null,
      type: Function,
    },
  },
  data: () => ({
    translations: {
      en: {
        button: 'Get extra info',
        items: [
          {
            active: true,
            title: 'What type of file should I upload?',
            description: 'You can upload a JPG, a PNG or PDF-files. It should contain 1 apartment or 1 house floor so AI could understand what it should visualize.',
          },
          {
            active: false,
            title: 'Can I change the interior design, furniture, wall color, etc.?',
            description: 'Our Quality Assurance team can customize your floor plan after rendering. Contact <a href="mailto:customerservice@getfloorplan.com">customerservice@getfloorplan.com</a> for editing.',
          },
          {
            active: false,
            title: 'Why will I get visuals in 24 hours?',
            description: 'Our Quality Assurance team checks every floor plan to make sure there are no mistakes after AI rendering. That is why a guaranteed result matching the original plan you receive in 24 hours',
          },
          {
            active: false,
            title: 'Can I get a refund?',
            description: 'You can send us an email to request a refund. Depending on the mean of payment you’ll receive your money back from 3 to 7 business days.',
          },
          {
            active: false,
            title: 'Can I choose 2 interior designs at once for 1 floor plan?',
            description: 'One chosen style is applied to all uploaded files. You should upload your floor plan for the second time to have it with another design',
          },
        ],
        title: 'FAQ',
      },
      ru: {
        button: 'Спросить',
        items: [
          {
            active: true,
            title: 'Какой тип файла мне нужно загрузить?',
            description: 'Вы можете загрузить JPG, PNG или PDF файлы. Один файл должен содержать 1 квартиру  или 1 этаж, так ИИ сможет распознать какой объект  нужно визуализировать.',
          },
          {
            active: false,
            title: 'Могу ли я изменить дизайн интерьера, мебель, цвет стен и т.д?',
            description: 'Наша команда по обеспечению качества может кастомизировать/персонализировать/адаптировать вашу планировку после рендеринга. Свяжитесь с <a href="mailto:customerservice@getfloorplan.com">customerservice@getfloorplan.com</a.',
          },
          {
            active: false,
            title: 'Почему я получу визуалы через 24 часа?',
            description: 'Наша команда по обеспечению качества проверяет каждую планировку, чтобы удостовериться в отсутствии ошибок после ИИ рендеринга. Поэтому гарантированный результат соответствующий вашей оригинальной планировке вы получите через 24 часа.',
          },
          {
            active: false,
            title: 'Могу я получить возврат средств?',
            description: 'Вы можете отправить нам письмо c запросом на возврат средств. В зависимости от способа оплаты вы получите обратно деньги в течение 3-7 рабочих дней.',
          },
          {
            active: false,
            title: 'Могу ли я выбрать 2 дизайна интерьера сразу для одной планировки?',
            description: 'Один выбранный стиль используется на все загруженные файлы. Вам необходимо загрузить планировку во второй раз для другого дизайна.',
          },
        ],
        title: 'Частые вопросы',
      },
    },
  }),
};
</script>
